import React, { useState, useEffect } from "react";
import { Grid, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import MUIDataTable from "mui-datatables";
import { db } from "../../context/firebase";
// components
import PageTitle from "../../components/PageTitle";
// import Widget from "../../components/Widget";
import Table from "../dashboard/components/Table/Table";
import { doc, getDocs, collection } from "firebase/firestore";
import {
  Button,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
} from "@material-ui/core";
import { deleteDoc } from "firebase/firestore";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

// styles
import useStyles from "./styles";
import { useTheme } from "@material-ui/styles";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 150,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 5,
};

export default function Dashboard(props) {
  var classes = useStyles();
  var theme = useTheme();
  const [ID, setID] = useState("");
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const [list, setList] = useState([]);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));


  var newList = [];

  const fetchList = async () => {
    // const response=doc(db,'users');
    const data = await getDocs(collection(db, "doubts"));

    data.docs.forEach((item) => {
      // console.log(list)
      newList.push([item.data().uid, item.data().query, item.data().queryID]);

      // newList.push({image: item._document.data.value.mapValue.fields.image.stringValue,
      //   name: item._document.data.value.mapValue.fields.name.stringValue,
      //   email: item._document.data.value.mapValue.fields.email.stringValue,
      //   ph: item._document.data.value.mapValue.fields.contactNumber.stringValue,
      //   batch: item._document.data.value.mapValue.fields.batch.stringValue});
    });
    // newList.push([item._document.data.value.mapValue.fields.name.stringValue,item._document.data.value.mapValue.fields.email.stringValue,item._document.data.value.mapValue.fields.batch.stringValue]);
    setList(newList);
  };

  useEffect(() => {
    fetchList();
  });

  //   var img=list.forEach(
  //     image=> {
  //     return(JSON.stringify(image[0]));
  //   } )
  //  console.log(img)
  const resolveDoubt = async () => {
    await deleteDoc(doc(db, "doubts", `${ID}`));
    handleClose();
  };

  

  return (
    <>
      <PageTitle title="Doubts" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Doubt Panel"
            data={list}
            columns={["Student UID", "Query", "QueryID"]}
            options={{
              filterType: "dropdown",
            }}
          />
        </Grid>
      </Grid>
      <Button
        className={classes.button}
        variant="contained"
        color="secondary"
        onClick={handleOpen}
      >
        Resolve Doubt
      </Button>
      {/* <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <input
            placeholder="Add the queryID"
            className="add-action"
            onChange={(event) => setID(event.target.value)}
          />

          <div className="button-container">
            <button className="add-docs" onClick={resolveDoubt}>
              Resolve and Clear
            </button>
          </div>
        </Box>
      </Modal> */}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Enter queryID!"}
        </DialogTitle>
        <DialogContent>
          <TextField
            id="outlined-basic"
            label="Add the queryID"
            variant="outlined"
            onChange={(event) => setID(event.target.value)}
          />
        </DialogContent>
        <DialogActions justify="center">
          <Button autoFocus onClick={resolveDoubt} variant="contained" color="primary">
            Resolve and Clear
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
